import PropTypes from 'prop-types'
import { Button, HStack } from '@chakra-ui/react'
import React, { useMemo } from 'react'
import { useLabels } from '../../utils/hooks/useLabels/useLabels'

const disabledProps = {
  bgColor: '#DDDDDD',
  borderColor: 'transparent',
  color: '#565656',
}
export default function FormButtons({
  noCancel,
  onBack,
  continueType,
  isForm,
  isValid,
  disabled,
  customCancelText,
  backVariant,
  onContinue = () => null,
}) {
  const newStyle = useMemo(
    () => (isForm && !isValid ? disabledProps : {}),
    [isForm, isValid],
  )
  const { texts } = useLabels()
  return (
    <HStack
      spacing="16px"
      alignSelf="center"
      w="60%"
      h="5vh"
      justifyContent="space-between"
    >
      {!noCancel && (
        <Button onClick={onBack} variant={backVariant || 'white'}>
          {customCancelText || texts.cancel}
        </Button>
      )}
      <Button
        type={continueType}
        disabled={disabled}
        onClick={onContinue}
        {...newStyle}
        variant="primary"
      >
        {texts.continue}
      </Button>
    </HStack>
  )
}

FormButtons.propTypes = {
  continueType: PropTypes.string,
  disabled: PropTypes.bool,
  customCancelText: PropTypes.string,
  isForm: PropTypes.bool,
  isValid: PropTypes.bool,
  noCancel: PropTypes.bool,
  onBack: PropTypes.func,
  backVariant: PropTypes.string,
  onContinue: PropTypes.func,
}
